import { ActionMenu } from "layouts/common/buttons";
import { TextLink } from "layouts/common/buttons";
import MDTypography from "ui/MDTypography";

export default function data(meetings, handleDelete, setNotification) {

  const rows = () => {
    return meetings?.map(meeting => {
      var { meetingdata } = meeting;
      console.log("meetings", meetingdata);
      return {
        title: (
          <TextLink
            link={`/meeting/${meeting.id}/detail`}
            text={meeting.title}
          />
        ),
        venue: (
          <MDTypography variant="caption" fontWeight="medium">
            {meeting.venue || "N/A"}
          </MDTypography>),
        createdBy: (
          <MDTypography variant="caption" fontWeight="medium">
            {meeting.createdBy?.name || "Unknown"}
          </MDTypography>),
        date: (
          <MDTypography variant="caption" fontWeight="medium">
            {meeting.date}
          </MDTypography>),
        dropdown: (
          <ActionMenu
            entity={meeting}
            basePath="meeting"
            onDelete={() => handleDelete(meeting.id)}
            setNotification={setNotification} // ✅ pass down from parent
          />
        ),

      }
    })
  }

  return {
    columns: [
      { Header: "Title", accessor: "title", align: "left" },
      { Header: "Venue", accessor: "venue", align: "left" },
      { Header: "Created By", accessor: "createdBy", align: "center" },
      { Header: "Date", accessor: "date", align: "right" }, // Add status column
      { accessor: "dropdown", align: "right" },
    ],
    rows: rows()
  };
}
